export const truncate = (text: string, cutOffPoint: number): string => {
  const ellipsis: string = '...'
  const truncateCutOffPoint: number = cutOffPoint - ellipsis.length
  return text.length > cutOffPoint
    ? `${text.slice(0, truncateCutOffPoint)}${ellipsis}`
    : text
}
